export default __webpack_public_path__ + "static/floor1_image1-sp-d024f6c6ae1d1c0d0cb65552533af1a2.png";